import PropTypes from 'prop-types';
import React from 'react';
import { compose, withHandlers, withProps } from 'recompose';
import { Dropdown } from 'semantic-ui-react';
import { logsTypes } from './../../constants';

const LogsTypeSelect = ({ types, onChange, value }) =>
    <Dropdown
        noResultsMessage="Brak wyników"
        onChange={onChange}
        options={types}
        placeholder="Wybierz typ logów"
        search
        selection
        value={value} />

LogsTypeSelect.propTypes = {
    types: PropTypes.array,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string
}

LogsTypeSelect.defaultProps = {
    types: []
}

const enhance = compose(
    withHandlers({
        onChange: ({ name, onChange }) => (event, { value }) => onChange(name, value)
    }),
    withProps({
        types: Object
            .keys(logsTypes)
            .map(key => ({
                value: key,
                text: logsTypes[key]
            }))
    })
);

export default enhance(LogsTypeSelect);


// WEBPACK FOOTER //
// ./src/components/form-fields/LogsTypeSelect.js